<template>
<div>
  <div class="card-header text-center border-bottom-0">
    <h1 class="h4">{{ $t("design.typography") }}</h1>
  </div>
  <div class="card-body">
    <div class="form form-lines">
      <p class="border-bottom pb-2"><em>$baseFont</em></p>
      <p class="base_title big"><span></span></p>
      <p class="medium">abcdefghijklmnñopqrstuvwxyz1234567890!!"·$%&amp;/()=</p>
      <p class="medium">ABCDEFGHIJKLMNÑOPQRSTUVWXYZ</p>
      <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Numquam doloribus porro nulla provident suscipit alias ullam, debitis ea odio aperiam quod rem cum, molestias temporibus maxime quisquam eius. Laboriosam, laudantium.</p>
      <p>Lorem <strong>ipsum dolor sit amet</strong>, <em>consectetur adipisicing elit</em>. In, voluptas deleniti quae, alias mollitia natus dolor voluptatem iste facere inventore ad sequi nulla aut quo fugiat eveniet numquam pariatur nesciunt.</p>

      <p class="border-bottom pb-2 mt-4 pt-4"><em>$titleFont</em></p>
      <p class="title_title big title_font"><span></span></p>
      <p class="medium title_font">abcdefghijklmnñopqrstuvwxyz1234567890!!"·$%&amp;/()=</p>
      <p class="medium title_font">ABCDEFGHIJKLMNÑOPQRSTUVWXYZ</p>
      <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Numquam doloribus porro nulla provident suscipit alias ullam, debitis ea odio aperiam quod rem cum, molestias temporibus maxime quisquam eius. Laboriosam, laudantium.</p>
      <p>Lorem <strong>ipsum dolor sit amet</strong>, <em>consectetur adipisicing elit</em>. In, voluptas deleniti quae, alias mollitia natus dolor voluptatem iste facere inventore ad sequi nulla aut quo fugiat eveniet numquam pariatur nesciunt.</p>
    </div>
  </div>
</div>
</template>
<style lang="scss" scoped="true">

  @import 'src/assets/styles/libs.scss';

  .big {
    font-weight: normal
  }
  .medium {
    font-size: 1.3rem;
  }

  .base_title {
    span {
      &:before {
        content: "#{$baseFont}";
        display: inline-block;
      }
    }
  }
  .title_title {
    span {
      &:before {
        content: "#{$titleFont}";
        display: inline-block;
      }
    }
  }
</style>
<script>
export default {
  name: 'Typography',
  components: {

  },
  data: function () {
    return {
      user: {}
    };
  },
  methods: {

  }
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/Styles/Typography.vue